import styled, { keyframes } from 'styled-components';

import { Text } from '@/nova/components';
import { CUST, CUST_ANIM, CUST_FONT } from '../../../../theme/customizer-tokens';

/** Full-viewport scrim covering the whole wizard (rail included) while the logo
 *  upload + background-removal run. */
export const Scrim = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 24px;
  text-align: center;
  font-family: ${CUST_FONT};
  background: ${CUST.logoProcessingScrim};
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  /* Capture every pointer event so the wizard underneath can't be touched. */
  pointer-events: auto;
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

/** A simple ring spinner — accent arc over a faint track. */
export const Spinner = styled.span`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 3px solid ${CUST.logoSpinnerTrack};
  border-top-color: ${CUST.accent};
  animation: ${spin} ${CUST_ANIM.SPIN_MS}ms linear infinite;

  /* Area convention: disable motion entirely (the copy still signals progress). */
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const Copy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;

export const Title = styled(Text)`
  font-size: 18px;
  font-weight: 800;
  color: ${CUST.white};
`;

export const Subtitle = styled(Text)`
  max-width: 320px;
  font-size: 14px;
  line-height: 1.4;
  color: ${CUST.textMuted};
`;
